import { Checkbox } from 'antd';
import React, { useContext } from 'react';
import { FormContext } from '../FormEngine';

const AmgenDrugCheckListInput = props => {
    const { def, data, onChange, state } = props;
    const MAXOPTIONS = 4 + 1;  //four additional options plus the originally selected drug. Necessary for LifeSciences

    const ctx = useContext(FormContext);
    var originalDrug = ctx.applicationDetails?.brandName || false;
    if (originalDrug === 'Neulasta Onpro Kit') originalDrug = 'Neulasta';
    const originalIndex = def.values.findIndex(val => val === originalDrug);

    if (data.length < 1) {
        onChange(def.dataKey, def.values.filter(val => val === originalDrug));
    }

    const onCheckListChange = (checkboxValues) => {
        if (!state.readonly) {
            if (data.length <= MAXOPTIONS) {
                onChange(def.dataKey, checkboxValues);
            }
        }
    }

    const checkDisabled = (val, selected) => {
        if (ctx.applicationDetails.isReenrollment) return true;

        var disabled = (data.length === MAXOPTIONS || val === originalDrug) && !selected;
        if (val === 'Prolia' && (data.includes('Xgeva') || originalDrug === 'Xgeva')) return true;
        if (val === 'Xgeva' && (data.includes('Prolia') || originalDrug === 'Prolia')) return true;

        return disabled;
    }

    return <Checkbox.Group onChange={onCheckListChange} value={data} data-input={'amgenchecklistinput_de'} className={'checklistinput_de'}>
        {def.values.filter(val => val === originalDrug).map((val, idx) => {
            return <>
                <Checkbox
                    key={`${def.dataKey}_${val}_${idx}`}
                    value={val}
                    disabled={true}
                >
                    {def.options[originalIndex]}
                </Checkbox>
                <br />
            </>;
        })}
        {def.values.filter(val => val !== originalDrug).map((val, idx) => {
            const selected = data.includes(val);
            const label = def.options.filter((_val, i) => i !== originalIndex)[idx];
            const disabled = checkDisabled(val, selected);
            return <>
                <Checkbox
                    key={`${def.dataKey}_${val}_${idx}`}
                    value={val}
                    disabled={disabled}
                >
                    {label}
                </Checkbox>
                <br />
            </>;
        })}
    </Checkbox.Group>
}

export default AmgenDrugCheckListInput;
